import {
  isSystemIdleDetectionSupported,
  requestSystemIdlePermission,
} from "./timeTrackerSystemIdle";
import { showErrorToast } from "../common/Toast";

/**
 * Request PC idle-detection permission during Check In (user gesture).
 * Desktop notification permission is temporarily disabled.
 * Returns { notifications, systemIdle }.
 */
export const requestTimeTrackerTrackingPermissions = async () => {
  const notifications = "unsupported";
  let systemIdle = "unsupported";

  // Desktop notification permission disabled — OS alerts are turned off.
  // if (isDesktopNotificationSupported()) { ... }

  if (isSystemIdleDetectionSupported()) {
    systemIdle = await requestSystemIdlePermission();
    if (systemIdle !== "granted") {
      showErrorToast(
        "Allow idle detection so Time Tracker can detect PC activity while you work in other tabs/apps. Without it, idle alerts will not use system activity."
      );
    }
  }

  return { notifications, systemIdle };
};
